(function () {
    "use strict";

    if (window.__customLandingInitialized) return;
    window.__customLandingInitialized = true;

    var root = document.querySelector(".custom-landing");
  
    /* Scroll reveal */
    var revealEls = root.querySelectorAll(".reveal");
    if (revealEls.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
                console.log('element'+ e);
                console.log('reveal');
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add("in");
      });
    }
  
    /* Hero initial reveal */
    var heroCopy = root.querySelector(".hero-copy.reveal");
    if (heroCopy) {
      setTimeout(function () {
        heroCopy.classList.add("in");
      }, 80);
    }
  
    /* Parallax — desktop/tablet only */
    var parallaxEls = root.querySelectorAll("[data-parallax]");
    var parallaxMq = window.matchMedia("(max-width: 900px)");
    function initParallax() {
      if (!parallaxEls.length || parallaxMq.matches) {
        parallaxEls.forEach(function (el) {
          el.style.transform = "";
        });
        return;
      }
      var strengths = [];
      parallaxEls.forEach(function (el) {
        strengths.push(parseFloat(el.getAttribute("data-parallax")) || 0.15);
      });
      var raf = 0;
      function onScroll() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          parallaxEls.forEach(function (el, i) {
            var rect = el.getBoundingClientRect();
            var center = rect.top + rect.height / 2;
            var dist = center - window.innerHeight / 2;
            var s = strengths[i];
            el.style.transform = "translate3d(0, " + dist * -s + "px, 0)";
          });
        });
      }
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }
    initParallax();
    parallaxMq.addEventListener("change", function () {
      window.removeEventListener("scroll", onScroll); // only if you store onScroll ref
      initParallax();
    });
  
    /* FAQ accordion */
    root.querySelectorAll(".faq-item").forEach(function (item) {
      var btn = item.querySelector(".faq-q");
      var panel = item.querySelector(".faq-a");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var wasOpen = item.classList.contains("open");
        root.querySelectorAll(".faq-item.open").forEach(function (other) {
          if (other !== item) {
            other.classList.remove("open");
            var p = other.querySelector(".faq-a");
            if (p) p.style.maxHeight = "0";
          }
        });
        if (wasOpen) {
          item.classList.remove("open");
          panel.style.maxHeight = "0";
        } else {
          item.classList.add("open");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  
  })();
  